import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppSettings } from '../../config/config';
import { apiConstants } from '../constant/apiConstant';

// Same /gettimetableclass endpoint StaffTimetableService.getClassTimetable
// calls, but with its own auth header instead of going through
// StaffApiInterceptor — that interceptor reads the staff/admin login's
// "usertoken" cookie, which a parent session never has (the parent's token
// lives in localStorage['authToken'], set by ParentLoginComponent), so a
// parent request routed through the shared staff service got no valid
// token and the API rejected it ("Please provide valid token"). Sending
// the header directly here, the same way parent-diary/parent-attendance's
// services already do, avoids that interceptor's cookie-based auth
// entirely for parent requests.
@Injectable({ providedIn: 'root' })
export class ParentTimetableService {

  private base = AppSettings.API_ENDPOINT_STAFF_BASE;
  private endpoint = apiConstants.getClassTimetable;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getClassTimetable(classId: string) {
    const params = new HttpParams().set('classId', classId);
    return this.http.get(`${this.base}${this.endpoint}`, { params, headers: this.authHeaders() });
  }
}
